import { type SimpleBuildingRelationApiResponse } from '../types/building';

type UnitRelationKeyOptions = {
  buildingRelationId: string;
  unitId: string;
};

const createUnitRelationKey = ({ buildingRelationId, unitId }: UnitRelationKeyOptions) =>
  `${buildingRelationId}-${unitId}`;

const createUnitOptions = (relation: SimpleBuildingRelationApiResponse) =>
  relation.units.map((unit) => ({
    data: relation,
    label: `${relation.displayName} - ${unit.registrationNumber}`,
    value: {
      buildingRelationId: relation.relationId,
      key: createUnitRelationKey({ buildingRelationId: relation.relationId, unitId: unit.unitId }),
      unitId: unit.unitId,
    },
  }));

export { createUnitOptions, createUnitRelationKey };
